export default __webpack_public_path__ + "static/media/036-djinguereber mosque.35e3a3a9.svg";